export default __webpack_public_path__ + "static/img/vogue_scene_animated_0534.7344b8a.jpg";